import AuthStatus from '../net/auth/AuthStatus'

const connected = () => AuthStatus.check() === AuthStatus.CONNECTED ;

export default connected ;